const { LOWER_CASE_SERVICE_NAME } = require("./constants");

export const isInternalDriverService = (serviceName = "") =>
  serviceName?.trim()?.toLowerCase() === LOWER_CASE_SERVICE_NAME.INTERNAL_DRIVER;
